export enum FulfilmentStatus {
    Pending = "PENDING",
    Error = "ERROR",
    Done = "DONE",
    PaymentError = "PAYMENT_ERROR",
}
